/**
 * OrangeHRM is a comprehensive Human Resource Management (HRM) System that captures
 * all the essential functionalities required for any enterprise.
 * Copyright (C) 2006 OrangeHRM Inc., http://www.orangehrm.com
 *
 * OrangeHRM is free software; you can redistribute it and/or modify it under the terms of
 * the GNU General Public License as published by the Free Software Foundation; either
 * version 2 of the License, or (at your option) any later version.
 *
 * OrangeHRM is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY;
 * without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.
 * See the GNU General Public License for more details.
 *
 * You should have received a copy of the GNU General Public License along with this program;
 * if not, write to the Free Software Foundation, Inc., 51 Franklin Street, Fifth Floor,
 * Boston, MA  02110-1301, USA
 */

import ViewMyPayslips from '@/orangehrmPayrollPlugin/pages/payrollMyPayslips/ViewMyPayslips.vue';
import ViewEmployeePayslips from '@/orangehrmPayrollPlugin/pages/payrollEmployeePayslips/ViewEmployeePayslips.vue';
import ViewPayrollEarnings from '@/orangehrmPayrollPlugin/pages/payrollEarnings/ViewPayrollEarnings.vue';
import ViewPayrollDeductions from '@/orangehrmPayrollPlugin/pages/payrollDeductions/ViewPayrollDeductions.vue';
import ViewPayrollGlobalDeductionRules from '@/orangehrmPayrollPlugin/pages/payrollGlobalDeductionRules/ViewPayrollGlobalDeductionRules.vue';
import ViewPayrollRuns from '@/orangehrmPayrollPlugin/pages/payrollRuns/ViewPayrollRuns.vue';
import ViewPayrollSummaryReport from '@/orangehrmPayrollPlugin/pages/payrollReports/ViewPayrollSummaryReport.vue';
import ViewPayrollPayslips from '@/orangehrmPayrollPlugin/pages/payrollPayslips/ViewPayrollPayslips.vue';
import PayslipsTemplatesEdit from '@/orangehrmPayrollPlugin/pages/payrollPayslipsTemplates/payslipsTemplatesEdit.vue';
import PayslipsTemplatesNew from '@/orangehrmPayrollPlugin/pages/payrollPayslipsTemplates/payslipsTemplatesNew.vue';
import ViewPayslipsTemplates from '@/orangehrmPayrollPlugin/pages/payrollPayslipsTemplates/viewPayslipsTemplates.vue';
import AddPayrollEarnings from '@/orangehrmPayrollPlugin/pages/payrollEarnings/AddPayrollEarnings.vue';
import EditPayrollEarnings from '@/orangehrmPayrollPlugin/pages/payrollEarnings/EditPayrollEarnings.vue';
import AddPayrollDeductions from '@/orangehrmPayrollPlugin/pages/payrollDeductions/AddPayrollDeductions.vue';
import EditPayrollDeductions from '@/orangehrmPayrollPlugin/pages/payrollDeductions/EditPayrollDeductions.vue';
import AddPayrollGlobalDeductionRule from '@/orangehrmPayrollPlugin/pages/payrollGlobalDeductionRules/AddPayrollGlobalDeductionRule.vue';
import EditPayrollGlobalDeductionRule from '@/orangehrmPayrollPlugin/pages/payrollGlobalDeductionRules/EditPayrollGlobalDeductionRule.vue';
import ViewPayrollConfig from '@/orangehrmPayrollPlugin/pages/payrollConfig/ViewPayrollConfig.vue';
import ViewPayrollEmployeeConfig from '@/orangehrmPayrollPlugin/pages/payrollConfig/ViewPayrollEmployeeConfig.vue';
import AddPayrollEmployeeConfig from '@/orangehrmPayrollPlugin/pages/payrollConfig/AddPayrollEmployeeConfig.vue';
import EditPayrollEmployeeConfig from '@/orangehrmPayrollPlugin/pages/payrollConfig/EditPayrollEmployeeConfig.vue';
import ViewPayrollTerSchedules from '@/orangehrmPayrollPlugin/pages/payrollConfig/ViewPayrollTerSchedules.vue';
import ViewPayrollEmailBatch from '@/orangehrmPayrollPlugin/pages/payrollEmailBatches/ViewPayrollEmailBatch.vue';
import EditPayrollPayslips from '@/orangehrmPayrollPlugin/pages/payrollPayslips/EditPayrollPayslips.vue';
import AddPayrollRuns from '@/orangehrmPayrollPlugin/pages/payrollRuns/AddPayrollRuns.vue';
import EditPayrollRuns from '@/orangehrmPayrollPlugin/pages/payrollRuns/EditPayrollRuns.vue';
import ViewMonthlyPayrollReport from '@/orangehrmPayrollPlugin/pages/payrollReports/ViewMonthlyPayrollReport.vue';

export default {
  'view-my-payslips': ViewMyPayslips,
  'view-employee-payslips': ViewEmployeePayslips,
  'view-payroll-earnings': ViewPayrollEarnings,
  'view-payroll-deductions': ViewPayrollDeductions,
  'view-payroll-global-deduction-rules': ViewPayrollGlobalDeductionRules,
  'view-payroll-runs': ViewPayrollRuns,
  'view-payroll-summary-report': ViewPayrollSummaryReport,
  'view-monthly-payroll-report': ViewMonthlyPayrollReport,
  'view-payroll-payslips': ViewPayrollPayslips,
  'payslip-templates-edit': PayslipsTemplatesEdit,
  'payslip-templates-new': PayslipsTemplatesNew,
  'view-payslip-templates': ViewPayslipsTemplates,
  'payroll-earning-new': AddPayrollEarnings,
  'payroll-earning-edit': EditPayrollEarnings,
  'payroll-deduction-new': AddPayrollDeductions,
  'payroll-deduction-edit': EditPayrollDeductions,
  'payroll-global-deduction-rule-new': AddPayrollGlobalDeductionRule,
  'payroll-global-deduction-rule-edit': EditPayrollGlobalDeductionRule,
  'view-payroll-config': ViewPayrollConfig,
  'view-payroll-employee-config': ViewPayrollEmployeeConfig,
  'view-payroll-ter-schedules': ViewPayrollTerSchedules,
  'payroll-employee-config-new': AddPayrollEmployeeConfig,
  'payroll-employee-config-edit': EditPayrollEmployeeConfig,
  'view-payroll-email-batch': ViewPayrollEmailBatch,
  'payroll-payslips-edit': EditPayrollPayslips,
  'payroll-runs-new': AddPayrollRuns,
  'payroll-runs-edit': EditPayrollRuns,
};
